import { useEffect, useState } from 'react';
import useVideoContext from './useVideoContext';
export var RoomState = {
  connected: 'connected',
  reconnecting: 'reconnecting',
  disconnected: 'disconnected'
};
export default function useRoomState() {
  var _useVideoContext = useVideoContext(),
      room = _useVideoContext.room;

  var _useState = useState(RoomState.disconnected),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    var setRoomState = function setRoomState() {
      return setState(room.state || RoomState.disconnected);
    };

    setRoomState();
    room.on('disconnected', setRoomState).on('reconnected', setRoomState).on('reconnecting', setRoomState);
    return function () {
      room.off('disconnected', setRoomState).off('reconnected', setRoomState).off('reconnecting', setRoomState);
    };
  }, [room]);
  return state;
}